/* global jQuery, Drupal */
(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.resizeVerticalMobile = {
    attach: function (context) {
      // Only enable on mobile
      if (window.innerWidth > 768) return;

      let resizing = null; // which element is currently being resized
      let startY, startHeight; // where the touch started, original height when touch started

      // Handle all resizable elements and textareas
      const selector = '.resize-vertical, .feedback-wrapper, .feedback-translation-wrapper, .form-textarea-wrapper, .essay-wrapper, .olex-reader-images-wrapper, .olex-analytics-detail-body_assignment-submission, .question-text-wrapper, .supporting-text-wrapper';

      $(selector, context).once('resize-mobile').each(function () {
        const $container = $(this);
        const isFeedback = $container.hasClass('feedback-wrapper') || $container.hasClass('feedback-translation-wrapper');
        const $target = isFeedback ? $container : $container.find('textarea').length ? $container.find('textarea') : $container;

        this.addEventListener('touchstart', function (e) {
          const rect = this.getBoundingClientRect(); // containers position and dimensions relative to viewport
          const touch = e.touches[0]; // first touch point - finger position
          const size = 50; // touch zone size

          if (touch.clientX > rect.right - size && touch.clientY > rect.bottom - size) { //  Check if touch is in bottom-right 50×50px corner
            resizing = $target;
            startY = touch.clientY;
            startHeight = $target.outerHeight();
            e.preventDefault();
          }
        }, { passive: false }); // stops page scrolling
      });

      document.addEventListener('touchmove', function (e) {
        if (!resizing) return;
        // Calculate new height
        const newHeight = Math.max(100, Math.min(window.innerHeight - 100, startHeight + e.touches[0].clientY - startY));
        resizing.css('height', newHeight + 'px'); //  Apply the new height
        e.preventDefault();
      }, { passive: false });

      document.addEventListener('touchend', () => resizing = null);
      document.addEventListener('touchcancel', () => resizing = null);
    }
  };

})(jQuery, Drupal);
